import { render, staticRenderFns } from "./IssueFarmRemoveDialog.vue?vue&type=template&id=252fa59b"
import script from "./IssueFarmRemoveDialog.vue?vue&type=script&lang=js"
export * from "./IssueFarmRemoveDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports